<template>
  <div class="page">
    <div class="page_title">雇员合作审批</div>
    <div class="form_row">
      <div class="label">姓名</div>
      <input class="input" v-model="name">
    </div>
    <div class="form_row">
      <div class="label">openId</div>
      <input class="input" v-model="userAccount">
    </div>
    <div class="form_row">
      <div class="label">状态</div>
      <select @change="changeState" class="input" v-model="currentState">
        <option v-for="(item,index) of employeeState" :key="index" :value="item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="table_container">
      <table class="table">
        <thead>
        <tr>
          <td>openId</td>
          <td>状态</td>
          <td>操作</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item of employeeList" :key="item.openId">
          <td>{{ item.userAccount }}</td>
          <td v-if="item.applyState == -1">驳回</td>
          <td v-else-if="item.applyState == 0">申请中</td>
          <td v-else-if="item.applyState == 1">成功</td>
          <td>
            <button class="button edit" @click="goViewEmployee(item)">查看</button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="loadMore" class="loadMore"><van-loading color="#07c160" size="24"/>加载更多</div>
      <div v-else class="loadMore">已加载所有雇员信息</div>
    </div>
  </div>
</template>

<script>
import {getEmployeeList,getEmployeeApplyList} from "../graphql/api";
import {watchScroll} from "../util";

export default {
  name: "config_employee",
  data() {
    return {
      name: null,  //搜索框的值
      userAccount: null,
      page: 1,
      size: 20,
      loadMore: true,
      employeeState: [
        {
          id: [0,-1,1],
          name: '不限'
        },
        {
          id: -1,
          name: '驳回'
        },
        {
          id: 0,
          name: '申请中'
        },
        {
          id: 1,
          name: '成功'
        }
      ],
      employeeList: [],
      currentState: [0,-1,1]
    }
  },
  watch:{
    currentState: function (){
      this.initVarible()
      console.log('状态变更', this.currentState);
      this.getEmployeeList()
    },
    name: function (){
      this.initVarible()
      console.log('名字变更', this.name);
      this.getEmployeeList()
    },
    userAccount: function (){
      this.initVarible()
      console.log('openId变更', this.userAccount);
      this.getEmployeeList()
    }
  },
  mounted() {
    // this.getEmployee();
    this.getEmployeeList()
    watchScroll(this.loadMore,this.getEmployeeList);
  },
  methods: {
    // 回归初始参数
    initVarible(){
      this.employeeList = [];
      this.page = 1;
    },

    // 查询雇员申请表
    getEmployeeList(){
      let params = {
        userAccount: this.userAccount,
        partnerId: sessionStorage.getItem('partnerid'),
        name: this.name,
        applyStateList: this.currentState,
        page: this.page
      };
      getEmployeeApplyList(params).then(res =>{
        if(this.name === ""){
          console.log('名字字符串为空');
          this.name = null
        }
        if(this.userAccount === ""){
          console.log('openid字符串为空');
          this.userAccount = null
        }
        console.log('查询到的雇员申请表为', res);
        console.log('查询所有雇员', res);
        if(!res.data.queryJoinApplyStaff){
          console.log('已加载所有网点');
          this.loadMore = false;
        }else{
          let data = res.data.queryJoinApplyStaff;
          if(data.length < this.size){
            this.loadMore = false;
          }else{
            this.page++;
          }
          for(const item of data){
            this.employeeList.push(item)
          }
        }
      })
    },

    // 查询雇员列表
    getEmployee(){
      if(this.name === ""){
        console.log('名字字符串为空');
        this.name = null
      }
      if(this.userAccount === ""){
        console.log('openid字符串为空');
        this.userAccount = null
      }
      let params = {
        partnerId: sessionStorage.getItem('partnerid'),
        name: this.name,
        userAccount: this.userAccount,
        stateList: this.currentState,
        page: this.page
      }
      getEmployeeList(params).then(res => {
        console.log('查询所有雇员', res);
        if(!res.data.queryEmployee){
          console.log('已加载所有网点');
          this.loadMore = false;
        }else{
          this.page++;
          let data = res.data.queryEmployee;
          for(const item of data){
            this.employeeList.push(item)
          }
        }
      })
    },

    // 雇员状态变更
    changeState() {

    },

    //  查看雇员详情
    goViewEmployee(item){
      this.$router.push({
        name: 'employee_detail',
        params:{
          person: item
        }
      })
    }
  }
}
</script>

<style src="../css/config_employee.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/employee_approval.vue